import { render, staticRenderFns } from "./BaseTableListCard.vue?vue&type=template&id=d6b50586"
import script from "./BaseTableListCard.vue?vue&type=script&lang=js"
export * from "./BaseTableListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports